import { NextResponse } from 'next/server'
import { query } from '@/lib/db'

export async function GET(req: Request) {
  const { searchParams } = new URL(req.url)
  const shopId = searchParams.get('shop_id')
  const date = searchParams.get('date')

  const ventes = await query<any>(`
    SELECT v.id, v.total, v.montant_encaisse, v.created_at,
      su.name as vendeur_name
    FROM ventes v
    LEFT JOIN shop_users su ON v.user_id = su.id
    WHERE v.shop_id = ? AND DATE(v.created_at) = ?
    ORDER BY v.created_at DESC
  `, [shopId, date])

  for (const vente of ventes) {
    const lignes = await query<any>(`
      SELECT vl.quantite, vl.prix_unitaire, vl.ras_mel_unitaire,
        a.name as article_name, a.unit
      FROM vente_lignes vl
      LEFT JOIN articles a ON vl.article_id = a.id
      WHERE vl.vente_id = ?
    `, [vente.id])
    vente.lignes = lignes
  }

  return NextResponse.json(ventes)
}
